<template>
<div id="PresentCourseManage">

  <div
    v-if="CourseManageShow"

    class="well"
    style="padding: 0 1em"
  >
    <div style="text-align: left; padding: 0.5rem 2rem">
      課程類別過濾：
      <b-form-select
        class="form-control"
        id="cidSelectText"
        v-model="selected"
        ref="selected"
        @change="UpdateAttributesClassID()"
        :options="options"
      >
      </b-form-select>

      <br />
      <button
        href="#"
        @click="AddCourse()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px; text-align: right"
      >
        新增課程
      </button>
     目前課程共 {{total}}筆
    </div>

    <b-tabs content-class="mt-3" justified>
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 14px;
          position: relative;
          overflow: auto;
          max-height: 100%;

          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
        <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
           fixed
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 2em">序號</b-th>
              <b-th style="min-width: 26em">課程名稱</b-th>
              <b-th style="min-width: 5em">上課日期</b-th>
              <b-th style="min-width: 2em">學費</b-th>
              <b-th style="min-width: 2em">招生人數(名額/已報名)</b-th>
              <b-th style="min-width: 5em">課程狀態</b-th>
              <b-th style="min-width: 20em">管理</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="ncut-tbody-menu">
            <b-tr
              v-for="(item, index) in filteredDocs"
              :key="item.cid"
              :index="item.cid"
              :name="item.cid"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </b-td>
              <b-td style="text-align: left">
                {{ item.courseName }}
              </b-td>
              <b-td style="text-align: left">{{ item.sdate }}</b-td>
              <b-td style="text-align: left">{{ item.courseCost }}</b-td>
              <b-td style="text-align: left">
                {{ item.primaryList }}/{{ item.secondaryList }}
                {{ item.primaryList == item.secondaryList ? "(額滿)" : "" }}
              </b-td>
              <b-td v-if="today <= item.closeDate" style="text-align: left">
                報名進行中
              </b-td>
              <b-td v-else style="text-align: left">
                {{ item.edate >= today ? "報名已截止" : "課程結束" }}
              </b-td>
              <b-td>
                <button
                  href="#"
                  @click="ListCourseDetail(item.cid)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  詳細
                </button>
                <button
                  href="#"
                  @click.prevent="signUpManage(item.cid)"
                  class="btn btn-outline-dark"
                  type="button"
                  style="font-size: 14px"
                >
                  報名管理
                </button>
                <button
                  href="#"
                  @click.prevent="EditCourse(item.cid)"
                  class="btn btn-outline-info"
                  type="button"
                  style="font-size: 14px"
                >
                  修改
                </button>
                <button
                  href="#"
                  @click.prevent="remove(item.cid)"
                  class="btn btn-outline-danger"
                  type="button"
                  style="font-size: 14px"
                >
                  刪除
                </button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>

    <b-modal size="xl" ref="ListCourseDetail" hide-footer>
      <template #modal-title> 課程詳細 </template>
      <ListCourseDetail
        :id="editId"
        @hideModal="hideModal('ListCourseDetail')"
      ></ListCourseDetail>
    </b-modal>
    <b-modal size="xl" ref="AddCourse" hide-footer>
      <template #modal-title> 新增課程 </template>
      <AddCourse @hideModal="hideModal('AddCourse')"></AddCourse>
    </b-modal>
    <b-modal size="xl" ref="EditCourse" hide-footer>
      <template #modal-title> 修改課程 </template>
      <EditCourse
        :id="editId"
        @hideModal="hideModal('EditCourse')"
      ></EditCourse>
    </b-modal>
    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>是否確認刪除此筆資料(包含此課程和學員參加報名資訊)?</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
        >取消刪除</b-button
      >
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
        >刪除確認</b-button
      >
    </b-modal>

  </div>

  <div v-else  class="well" style="padding: 0 1em">
    <div style="text-align: left; padding: 0.5rem 2rem">
      <button
        href="#"
        @click.prevent="backCourseList()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回課程列表
      </button>
    </div>
    <br />
    <div style="font-size: 20px; text-align: left; padding: 0.5rem 2rem">
      {{ courseName }}報名清單共{{total}}筆
    </div>

    <b-tabs content-class="mt-3" justified>
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 14px;
          position: relative;
          overflow: auto;
          max-height: 100%;

          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
          <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
          fixed
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 1em">序號</b-th>
              <b-th style="min-width: 5em">報名者</b-th>
              <b-th style="min-width: 5em">報名時間</b-th>
              <b-th style="min-width: 5em">停車證</b-th>
              <b-th style="min-width: 2em">學費(原價)</b-th>
              <b-th style="min-width: 2em">學費(優惠價)</b-th>
              <b-th style="min-width: 2em">審核狀態</b-th>
              <b-th colspan="2" style="min-width: 20em">繳費帳號</b-th>
              <b-th style="min-width: 2em">繳費入帳狀態</b-th>
              <b-th style="min-width: 2em">優惠方式</b-th>
              <b-th style="min-width: 5em">審核</b-th>
              <b-th style="min-width: 5em">管理</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="ncut-tbody-menu">
            <b-tr
              v-for="(item, index) in filteredDocs2"
              :key="item.SignUpID"
              :index="item.SignUpID"
              :name="item.SignUpID"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ (currentPage2 - 1) * pageSize + index + 1 }}
              </b-td>
              <b-td style="text-align: left">
                {{ item.name }}
              </b-td>
              <b-td style="text-align: left">{{ item.updateTimeString }}</b-td>
              <b-td style="text-align: left">{{ item.plateNumber }}</b-td>
              <b-td style="text-align: left">{{ item.courseCost }}</b-td>
              <b-td style="text-align: left">{{ item.specialPrice }}</b-td>
              <b-td v-if="item.isComplete == 0" style="text-align: left">
                尚未審核
              </b-td>
              <b-td v-else style="text-align: left">
                {{ item.isComplete == 1 ? "報名通過" : "報名不通過" }}
              </b-td>
              <b-td colspan="2"  style="text-align: left">{{ item.account }}</b-td>
              <b-td v-if="item.isPayment == 1" style="text-align: left"
                  >已繳費
                </b-td>
                  <b-td v-else style="text-align: left">
                    未繳費
                </b-td>
              <b-td style="text-align: left">{{ item.specialPriceClassText }}</b-td>
              <b-td style="text-align: left">
                <button
                  href="#"
                  @click="review(item.signUpID,1)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  核准報名
                </button>
                <button
                  href="#"
                  @click="review(item.signUpID,2)"
                  class="btn btn-outline-secondary"
                  type="button"
                  style="font-size: 14px"
                >
                  資格不符
                </button>
              </b-td>
              <b-td style="text-align: left">
                <button
                  href="#"
                  @click="ListDetailMemberData(item.stdID,item.memberClass)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  修改資料
                </button>
                <button
                  href="#"
                  @click="remove2(item.signUpID)"
                  class="btn btn-outline-danger"
                  type="button"
                  style="font-size: 14px"
                >
                  刪除
                </button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage2"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>

    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>是否確認刪除此筆資料?</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM2"
        >取消刪除</b-button
      >
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM2"
        >刪除確認</b-button
      >
    </b-modal>
  </div>

  <b-modal size="xl"  ref="EditEnterpriseMember2" hide-footer>
      <template #modal-title> 企業會員報名者資料檢視 </template>
      <EditEnterpriseMember2
        :StdID="editId"
        @hideModal="hideModal('EditEnterpriseMember2')"
      ></EditEnterpriseMember2>
    </b-modal>
     <b-modal size="xl"  ref="EditGeneralMember2" hide-footer>
      <template #modal-title> 會員報名者資料檢視 </template>
      <EditGeneralMember2
        :StdID="editId"
        @hideModal="hideModal('EditGeneralMember2')"
      ></EditGeneralMember2>
    </b-modal>
  </div>
</template>

<script>
import ListCourseDetail from '@/components/ListCourseDetail.vue'
import AddCourse from '@/components/AddCourse.vue'
import EditCourse from '@/components/EditCourse.vue'
import EditEnterpriseMember2 from '@/components/EditEnterpriseMemberView2.vue'
import EditGeneralMember2 from '@/components/EditGeneralMemberView2.vue'
import * as tools from '../tool'
export default {
  name: 'PresentCourseManage',
  data () {
    return {
      courseName: null,
      CourseManageShow: false,
      cid: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: 1,
      options: [
        { value: '1', text: '現職人才培育課程' },
        { value: '2', text: '專業證照課程' }
      ],
      attributesClassID: 1,
      editId: 0,
      over: 0,
      total: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sysId: 0
      }
    }
  },
  components: {
    ListCourseDetail,
    AddCourse,
    EditCourse,
    EditEnterpriseMember2,
    EditGeneralMember2
  },
  methods: {
    backCourseList () {
      this.CourseManageShow = true
      this.getAllCourse(this.attributesClassID)
    },
    getSignUpList (cid) {
      const vm = this

      this.$http
        .get('./WebApi/ociaRep/GetociaSignUpList/'.concat(cid))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data
            if (vm.inputData2.length != null) { vm.total = vm.inputData2.length }
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        })
    },
    signUpManage (cid) {
      for (var i = 0; i < this.inputData.length; i++) {
        if (this.inputData[i].cid == cid) {
          this.courseName = this.inputData[i].courseName
          this.cid = this.inputData[i].cid
          this.attributesClassID = this.inputData[i].attributesClassID
        }
      }

      this.getSignUpList(this.cid)
      this.CourseManageShow = false
    },

    getToday () {
      var dd = new Date()
      var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      this.today = tools.stringFormat('{0}-{1}-{2}', yyyy, mm, today)
    },
    UpdateAttributesClassID () {
      const obj = document.getElementById('cidSelectText')
      this.attributesClassID = obj.options[obj.selectedIndex].value
      this.getAllCourse(this.attributesClassID)
    },
    getAllCourse (data) {
      if (data == 0) this.attributesClassID = ''

      const vm = this

      this.$http
        .get('./WebApi/ociaRep/GetociaRepList2/'.concat(vm.attributesClassID))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            vm.total = vm.inputData.length
  	    vm.currentPage = 1
            vm.currentPage2 = 1
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        })
    },
    AddCourse () {
      var vm = this
      vm.$refs.AddCourse.show()
    },
    EditCourse (id) {
      var vm = this
      vm.editId = id
      vm.$refs.EditCourse.show()
    },
    ListCourseDetail (id) {
      var vm = this
      vm.editId = id
      vm.$refs.ListCourseDetail.show()
    },
    ListDetailMemberData (id, MemberClass) {
      var vm = this
      vm.editId = id
      if (MemberClass == 0) { vm.$refs.EditGeneralMember2.show() } // 普通會員
      else { vm.$refs.EditEnterpriseMember2.show() } // 企業會員
    },
    remove (cid) {
      this.cid = cid
      this.$refs['q-modal'].show()
    },
    cancalRM () {
      this.$refs['q-modal'].hide()
    },
    hideModal (name) {
      this.$refs[name].hide()
      this.getAllCourse(this.attributesClassID)
    },
    confirmRM () { // 刪除課程資料
      this.$refs['q-modal'].hide()
      var vm = this
      this.$http
        .get('./WebApi/ociaRep/RemoveCourse/'.concat(this.cid))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,刪除成功')
            vm.getAllCourse(vm.attributesClassID)
          } else {
            tools.showAlert(vm, 'danger', '對不起,刪除失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    remove2 (signUpID) {
      this.signUpID = signUpID
      this.$refs['q-modal'].show()
    },
    cancalRM2 () {
      this.$refs['q-modal'].hide()
    },
    confirmRM2 () { // 刪除報名資料
      this.$refs['q-modal'].hide()
      var vm = this
      this.$http
        .get('./WebApi/ociaRep/RemoveSignUp/'.concat(this.signUpID + '/' + this.cid))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,刪除成功')
            vm.getSignUpList(this.cid)
          } else {
            tools.showAlert(vm, 'danger', '對不起,刪除失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    review (signUpID, isComplete) { // 核准報名資料,1:報名通過,2:資格不符
      var vm = this
      this.$http
        .get('./WebApi/ociaRep/ReviewSignUp/'.concat(signUpID).concat('/').concat(isComplete))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,審核成功')
            vm.getSignUpList(this.cid)
          } else {
            tools.showAlert(vm, 'danger', '對不起,審核失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    filteredDocs2: function () {
      let data = []
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }

  },
  created () {
    console.log('======created PresentCourseManageView =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1
    const vm = this
    vm.getToday()
    vm.CourseManageShow = true
    vm.getAllCourse(vm.attributesClassID)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
